import { SvgCheck } from '@common/icon';
import { cn } from '@core/utils';

import { useSubscribedState } from '@/hooks/useSubscribedState';
import type { HTMLTagProps } from '@/types';

export interface CheckboxProps
  extends Pick<HTMLTagProps<'div'>, 'className' | 'style'>,
    Omit<
      HTMLTagProps<'input'>,
      'size' | 'type' | 'style' | 'value' | 'children'
    > {
  children?: React.ReactNode;
  checkable?: boolean;
}

/**
 * 이거 안 쓰면 이상하게 작동함
 * 다른 페이지에서는 사용하지 말 것
 *
 * @deprecated
 */
export const Checkbox = ({
  //* Checkbox props
  children,
  checkable = true,

  //* HTML div props
  className,
  style,

  //* HTML input props
  checked,
  onChange,
  disabled,
  ref,
  ...restInputProps
}: CheckboxProps & { ref?: React.Ref<HTMLInputElement> }) => {
    const [turned, setTurned] = useSubscribedState(checked);

    return (
      <label
        className={cn('flex w-fit items-center gap-8', className)}
        style={style}
      >
        <div
          className={cn(
            'flex size-16 min-h-16 min-w-16 cursor-pointer items-center justify-center rounded-xxsmall border-[1.5px] transition-[background-color,border-color] duration-200 ease-in-out',
            turned
              ? 'text-white border-Gray-black bg-Gray-black'
              : 'bg-white border-Gray-500 text-transparent',
            disabled &&
              'cursor-not-allowed border-Gray-500 bg-Gray-300 text-Gray-500',
          )}
        >
          {turned ? <SvgCheck /> : null}
        </div>
        <input
          {...restInputProps}
          ref={ref}
          readOnly
          checked={turned}
          className="hidden"
          disabled={disabled}
          type="checkbox"
          onChange={(e) => {
            if (checkable) {
              onChange?.(e);

              setTurned((prev) => !prev);
            }
          }}
        />
        {children}
      </label>
    );
};
